import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { wrapIdForCustomContent } from '@src/framework/workbench/util/wrap-id-util';
import * as React from 'react';
import FONT_EFFECT from '@tencent/docs-design-resources/icon/desktop/svg/text_effect_light_24.svg';
import FONT_BORDER from '@tencent/docs-design-resources/icon/desktop/svg/text_outline_light_24.svg';

export const fontBorderToolbar = {
    id: ActionType.FONT_BORDER_TOOLBAR,
    content: i18n.t('文字轮廓'),
};

export const fontEffectToolbar = {
    id: ActionType.FONT_EFFECT_TOOLBAR,
    content: i18n.t('文字效果'),
};

export const fontShadowToolbar = {
    id: ActionType.FONT_SHADOW_TOOLBAR,
    content: i18n.t('阴影'),
};

export const fontReflectionToolbar = {
    id: ActionType.FONT_REFLECTION_TOOLBAR,
    content: i18n.t('映像'),
};

export const fontGlowToolbar = {
    id: ActionType.FONT_GLOW_TOOLBAR,
    content: i18n.t('发光'),
};

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: fontEffectToolbar.id,
        content: fontEffectToolbar.content,
    },
    {
        name: fontShadowToolbar.id,
        content: fontShadowToolbar.content,
    },
    {
        name: fontReflectionToolbar.id,
        content: fontReflectionToolbar.content,
    },
    {
        name: fontGlowToolbar.id,
        content: fontGlowToolbar.content,
    },
    {
        name: wrapIdForCustomContent(fontShadowToolbar.id),
        style: {
            width: '200px',
            overflow: 'hidden',
            padding: 0,
            height: 'auto',
        },
    },
    {
        name: wrapIdForCustomContent(fontReflectionToolbar.id),
        style: {
            width: '200px',
            overflow: 'hidden',
            padding: 0,
            height: 'auto',
        },
    },
    {
        name: wrapIdForCustomContent(fontGlowToolbar.id),
        style: {
            width: '200px',
            overflow: 'hidden',
            padding: 0,
            height: 'auto',
        },
    },
];

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: fontBorderToolbar.id,
        tooltip: fontBorderToolbar.content,
        icon: <img src={FONT_BORDER} alt={''} />,
        hasArrow: true,
        color: '#ffffff',
    },
    {
        name: fontEffectToolbar.id,
        tooltip: i18n.t('文字效果'),
        icon: <img src={FONT_EFFECT} alt={''} />,
        hasArrow: true,
    },
];
